import * as React from "react"
import colors from "@digits-shared/themes/colors"
import {
  SolidFill,
  VerticalAngledGradient,
  VerticalGradient,
} from "src/frontend/components/OS/Shared/Charts/Coloring"
import { SharedBarChartStyles } from "src/frontend/components/OS/Shared/Charts/styles"

export const BAR_FILL_ID = "bar-fill"
export const BAR_BORDER_ID = "bar-border"
export const SELECTED_BAR_FILL_ID = "selected-bar-fill"
export const INACTIVE_BAR_FILL_ID = "inactive-bar-fill"
export const HIGHLIGHT_BAR_FILL_ID = "highlight-bar-fill"
export const EMPTY_BAR_FILL_ID = "empty-bar-fill"
export const SELECTED_BAR_BORDER_ID = "selected-bar-border"

interface BarSummaryChartGradientsProps {
  id: string
}

export const BarSummaryChartGradients: React.FC<BarSummaryChartGradientsProps> = ({ id }) => (
  <>
    <VerticalAngledGradient
      id={`${id}-${BAR_FILL_ID}`}
      color={SharedBarChartStyles.barFillColor}
      bottomColor={SharedBarChartStyles.barFillBottomColor}
    />
    <VerticalAngledGradient
      id={`${id}-${BAR_FILL_ID}-inverted`}
      color={SharedBarChartStyles.barFillNegativeColor}
      bottomColor={SharedBarChartStyles.barFillNegativeBottomColor}
    />
    <VerticalAngledGradient
      id={`${id}-${HIGHLIGHT_BAR_FILL_ID}`}
      color={SharedBarChartStyles.barFillHighlightedColor}
      bottomColor={SharedBarChartStyles.barFillHighlightedBottomColor}
    />
    <VerticalAngledGradient
      id={`${id}-${HIGHLIGHT_BAR_FILL_ID}-inverted`}
      color={SharedBarChartStyles.barFillNegativeColor}
      bottomColor={SharedBarChartStyles.barFillNegativeBottomColor}
    />
    <VerticalGradient
      id={`${id}-${SELECTED_BAR_FILL_ID}`}
      color={SharedBarChartStyles.barFillColor}
      bottomColor={SharedBarChartStyles.barFillBottomColor}
    />
    <VerticalAngledGradient
      id={`${id}-${SELECTED_BAR_FILL_ID}-inverted`}
      color={SharedBarChartStyles.barFillNegativeColor}
      bottomColor={SharedBarChartStyles.barFillNegativeBottomColor}
    />
    <VerticalGradient
      id={`${id}-${INACTIVE_BAR_FILL_ID}`}
      color={SharedBarChartStyles.barFillInactiveColor}
      bottomColor={SharedBarChartStyles.barFillInactiveBottomColor}
    />

    <SolidFill id={`${id}-${EMPTY_BAR_FILL_ID}`} withOpacity color={colors.translucentWhite04} />
  </>
)
